module.exports = __webpack_public_path__ + "img/google-reviews.ca867563.webp";